import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PictureInfo } from "../photo-viewmodel";

@Component({
  selector: "app-fullscreen-photo",
  templateUrl: "./fullscreen-photo.component.html",
  styleUrls: ["./fullscreen-photo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullscreenPhotoComponent implements OnInit {
  @Input() photo: PictureInfo;

  constructor(
    private _sanitizer: DomSanitizer,
    private _modal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    document
      .getElementById("fullscreenWrapper")
      .style.setProperty("--height", `${window.innerHeight - 4}px`);
  }

  @HostListener("window:resize")
  onResize() {
    document
      .getElementById("fullscreenWrapper")
      .style.setProperty("--height", `${window.innerHeight - 4}px`); // otherwise you get a scrollbar on mobile :(
  }

  transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  closeImage() {
    this._modal.close();
  }
}
